import React, { useEffect, useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import NavTab from '../../shared/components/custom/NavTab';
import LazyTabPane from '../../shared/components/custom/LazyTabPane';
import { fetchClubNames } from '../transactions/connect';
import AccountingMonths from './AccountingMonths';
import AccountingAgreements from './AccountingAgreements';
import { p } from './accounting';

// Super-users (a tab in Club administration): settling auctions with each
// club per month, and the cut agreed with each club.
const AccountingTab = () => {
  const [tab, setTab] = useState('1');
  const [clubNames, setClubNames] = useState({});

  useEffect(() => {
    fetchClubNames().then(setClubNames);
  }, []);

  return (
    <>
      {/* Its own query param: Club administration's tabs use ?tab= */}
      <NavTab
        activeTab={tab}
        tabs={[p('months'), p('agreements')]}
        setTab={setTab}
        queryName="accountingTab"
        size="sm"
      />
      <TabContent activeTab={tab}>
        <TabPane tabId="1">
          <AccountingMonths clubNames={clubNames} />
        </TabPane>
        <LazyTabPane activeTab={tab} tabId="2">
          <AccountingAgreements clubNames={clubNames} />
        </LazyTabPane>
      </TabContent>
    </>
  );
};

export default AccountingTab;
